import { get } from 'lodash';
import {
  RESERVED_KEY,
  API_ERROR_TYPES,
  REQUIRED_FIELDS,
} from 'apps/apiRedirect/redirectTypes';
import {
  actionByType,
} from 'apps/apiRedirect/actions/apiRedirect';
import { isElevatedLoginEnabled } from 'apps/login/utils';

export default class ApiRedirectsPreprocessor {
  static isPredefinedResponse(data = {}) {
    const type = data[RESERVED_KEY];
    return (
      typeof type !== 'undefined'
      && API_ERROR_TYPES.includes(type)
      && REQUIRED_FIELDS[type].every((field) => typeof data[field] !== 'undefined')
    );
  }

  handleResponse(opts) {
    if (!this.store) {
      throw new Error('[ApiRedirectHandler] Can\'t handle redirect - store not available.');
    }
    const data = opts.data || {};
    const type = data[RESERVED_KEY];
    const betaFeatures = get(this.store.getState(), 'user.betaFeatures', []);
    const loginElevatedInRavenEnabled = isElevatedLoginEnabled(betaFeatures);

    const action = actionByType({
      type,
      data,
      currentUrl: opts.currentUrl,
      callback: opts.callback,
      loginElevatedInRavenEnabled,
    });
    if (!action) {
      return null;
    }
    return action.redirect;
  }

  setStore(store) {
    this.store = store;
  }
}
